import React from 'react';
import { motion } from 'framer-motion';
import { DollarSign, Heart, Plane, Leaf, TrendingUp, Home } from 'lucide-react';

const CareersPerksSection: React.FC = () => {
  const perks = [
    {
      title: 'Competitive salary & equity',
      description: 'Velit officia enim dolore sit tempor qui sunt ut qui voluptate id eu sunt',
      icon: DollarSign,
      bgColor: 'bg-brand-yellow',
      textColor: 'text-white',
      iconColor: 'text-white',
      rounded: 'rounded-[20px]'
    },
    {
      title: 'Heath, dental and vision insurance',
      description: 'Velit officia enim dolore sit tempor qui sunt ut qui voluptate id eu sunt',
      icon: Heart,
      bgColor: 'bg-white',
      textColor: 'text-brand-yellow',
      iconColor: 'text-brand-yellow',
      rounded: 'rounded-tl-[20px] rounded-tr-[20px]'
    },
    {
      title: 'Unlimited days off',
      description: 'Velit officia enim dolore sit tempor qui sunt ut qui voluptate id eu sunt',
      icon: Plane,
      bgColor: 'bg-brand-yellow',
      textColor: 'text-white',
      iconColor: 'text-white',
      rounded: 'rounded-[20px]'
    },
    {
      title: 'Learning & development',
      description: 'Velit officia enim dolore sit tempor qui sunt ut qui voluptate id eu sunt',
      icon: TrendingUp,
      bgColor: 'bg-brand-yellow',
      textColor: 'text-white',
      iconColor: 'text-white',
      rounded: 'rounded-[20px]'
    },
    {
      title: 'Mental health & wellness benefits',
      description: 'Velit officia enim dolore sit tempor qui sunt ut qui voluptate id eu sunt',
      icon: Leaf,
      bgColor: 'bg-white',
      textColor: 'text-brand-yellow',
      iconColor: 'text-brand-yellow',
      rounded: 'rounded-bl-[20px] rounded-tl-[20px]'
    },
    {
      title: 'Work from home',
      description: 'Velit officia enim dolore sit tempor qui sunt ut qui voluptate id eu sunt',
      icon: Home,
      bgColor: 'bg-white',
      textColor: 'text-brand-yellow',
      iconColor: 'text-brand-yellow',
      rounded: 'rounded-br-[20px] rounded-tr-[20px]'
    }
  ];

  return (
    <section className="relative bg-brand-yellow py-16 lg:py-20">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="font-open-sans font-bold text-[52px] leading-[74px] text-white text-center mb-16"
          style={{ fontVariationSettings: "'wdth' 100" }}
        >
          Perks
        </motion.h2>

        {/* Perks Grid - 3x2 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-[960px] mx-auto">
          {perks.map((perk, index) => {
            const IconComponent = perk.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className={`${perk.bgColor} ${perk.rounded} p-9 shadow-card`}
                style={{ height: '294px' }}
              >
                {/* Icon */}
                <div className={`${perk.iconColor} mb-4`} style={{ width: '48px', height: '48px' }}>
                  <IconComponent className="w-full h-full" />
                </div>

                {/* Title */}
                <h3 className={`font-open-sans font-bold text-[24px] leading-[36px] ${perk.textColor} mb-4`} style={{ fontVariationSettings: "'wdth' 100" }}>
                  {perk.title}
                </h3>

                {/* Description */}
                <p className={`font-open-sans font-normal text-[16px] leading-[26px] ${perk.textColor}`} style={{ fontVariationSettings: "'wdth' 100", height: '82px' }}>
                  {perk.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CareersPerksSection;
